export default __webpack_public_path__ + "675fcc66b5a6a808d413299a11db3424.png";